import React from 'react';
import { withTranslate } from 'react-redux-multilingual';


function Vi(props) {
    const { translate } = props;
    return (
        <div className="wrap">
            <h1>Điều khoản và Điều kiện sử dụng</h1>
            <div>
                <div className="contents">
                    <div name="gioithieu">
                        <h2>Giới thiệu</h2>
                        <p>Chào mừng bạn đã đến với website của RPA CLOUD (gọi chung là “chúng tôi” hoặc “của chúng tôi”).
                            Vì lợi ích của chính bạn, vui lòng đọc kĩ các điều khoản và điều kiện sử dụng của website trước khi truy cập
                            hoặc sử dụng bất kì dịch vụ nào của trang web.
                        </p>
                        <p>Bạn có thể ngừng sử dụng trang web này nếu bạn không đồng ý với bất kỳ điều khoản nào dưới đây.
                        </p>
                        <p>Trang web được kiểm soát và vận hành bởi RPA CLOUD.</p>
                    </div>
                    <div name="d1">
                        <h2>Điều 1. Định nghĩa</h2>
                        <p>
                            Định nghĩa của các điều khoản trong thỏa thuận này như sau :
                        </p>
                        <div>
                            <ol>
                                <li>
                                    <span className="bold-style">Quyền sở hữu trí tuệ:</span>
                                    <br />
                                    Bao gồm tất cả nội dung và tài liệu trên
                                    trang web,bao gồm nhưng không giới hạn nội dung,thiết kế, các tệp âm thanh, tệp video, nhãn hiệu,
                                    tên thương hiệu, tên miền, biểu tượng, khẩu hiệu, logo, hình ảnh, phần mềm và/hoặc các quyền sở hữu
                                    trí tuệ khác (Tài sản trí tuệ) được bảo vệ bởi luật bản quyền, nhãn hiệu, các bảo hộ
                                    thương mại khác và các hình thức quyền sở hữu trí tuệ khác mà RPA CLOUD, luôn có tất cả các quyền,
                                    lợi ích và quyền sở hữu.Việc bạn sử dụng Dịch vụ của chúng tôi không có nghĩa là bạn được sở hữu bất cứ các quyền sở hữu trí tuệ nào đối với Dịch vụ của chúng tôi hoặc nội dung mà bạn truy cập. 
    
                                </li>
                                <li>
                                    <span className="bold-style">Người dùng:</span>
                                    <br />
                                    Cá nhân hoặc tập thể đồng ý với thỏa thuận này, đăng
                                    ký sử dụng dịch vụ theo quy định tại Điều 2.
                                </li>
                                <li>
                                    <span className="bold-style">Tài khoản:</span>
                                    <br />
                                    Là tên người dùng và mật khẩu để đăng nhập vào dịch vụ , địa chỉ
                                    e-mail, đường link truy cập và các thông tin khác cần thiết để người dùng truy cập dịch vụ.
                                </li>
                                <li>
                                    <span className="bold-style">Dịch vụ:</span>
                                    <br />
                                    Là dịch vụ chúng tôi cung cấp với tên gọi RPA CLOUD, dịch
                                    vụ cho phép người dùng tạo ra các robot để tự động hóa nghiệp vụ.
                                </li>
                            </ol>
                        </div>
    
                    </div>
                    <div name="d2">
                        <h2>Điều 2. Đăng ký sử dụng</h2>
                        <p>Những người muốn sử dụng dịch vụ (sau đây gọi là “người dùng”) sẽ thực hiện việc tạo tài khoản
                            trên website của chúng tôi. Hệ thống sẽ khởi tạo tài khoản tự động ngay sau khi việc đăng ký thành
                            công.Tuy nhiên, chúng tôi có toàn quyền từ chối cung cấp dịch vụ nếu người dùng thuộc bất kỳ nội dung
                            nào sau
                            đây :
                        </p>
                        <ol>
                            <li>Khi người dùng vi phạm bất kỳ điều khoản nào đã được quy định trong văn bản này.</li>
                            <li>Khi người dùng đã bỏ qua nghĩa vụ đối với chúng tôi trong quá khứ hoặc khi chúng tôi xác
                                định rằng người dùng có nguy cơ bỏ qua nghĩa vụ đó trong tương lai.
                            </li>
                            <li>Khi chúng tôi xác định rằng việc cung cấp liên tục dịch vụ này là khó khăn vì những lý do
                                hợp lý.
                            </li>
                            <li>Khi chúng tôi xác định rằng có trở ngại đáng kể đối với hoạt động kinh doanh của chúng tôi.</li>
                        </ol>
                    </div>
                    <div name="d3">
                        <h2>Điều 3. Phát hành và quản lý tài khoản</h2>
                        <ol>
                            <li>Người dùng không thể chia sẻ và sử dụng một tài khoản với nhiều người.
                            </li>
                            <li>Người dùng phải tự chịu rủi ro quản lý và lưu trữ tài khoản liên quan đến dịch vụ này và
                                không được cho phép bên thứ ba sử dụng, cho mượn, chuyển nhượng, đổi tên, mua hoặc bán, v.v. Ngoài ra,
                                người dùng phải chịu trách nhiệm về hành vi vi phạm của bản thân.
                            </li>
                            <li>Người dùng sẽ phải chịu hoàn toàn trách nhiệm  về những thiệt hại do quản lý tài khoản không đầy đủ, sử
                                dụng nhầm lẫn, sử dụng bởi bên thứ ba, v.v. 
                            </li>
                            <li>Nếu phát hiện thông tin tài khoản bị đánh cắp hoặc bị bên thứ ba sử dụng, người dùng phải
                                thông báo ngay cho chúng tôi và làm theo hướng dẫn từ chúng tôi.             
                            </li>
                        </ol>
                    </div>
                    <div name="d4">
                        <h2>Điều 4. Thời gian sử dụng</h2>
                        <ol>
                            <li>
                                Đối với bản dùng thử : Người dùng có thể sử dụng tối đa 60 ngày miễn phí dựa vào thời điểm đăng ký sử dụng. Hết thời hạn này, nếu người dùng không chuyển đổi
                                sang bản có phí, người dùng sẽ không thể tiếp tục đăng nhập. Sau 30 ngày kể từ ngày hết hạn sử dụng
                                miễn phí, chúng tôi sẽ tiến hành xóa vĩnh viễn tài khoản và những nội dung thao tác người dùng đã thực
                                hiện trên hệ thống. Một tài khoản chỉ được sử dụng 1 bản dùng thử duy nhất một lần.
                            </li>
                            <li> Đối với bản có phí: Chi phí sẽ được thanh toán mỗi tháng với hình thức thanh toán trước sử
                                dụng sau.Chúng tôi không có chính sách hoàn trả chi phí. Khi không nhận được thanh toán chúng tôi
                                sẽ tạm ngưng tài khoản trong 30 ngày ,sau đó chúng tôi sẽ tiến hành hành xóa vĩnh viễn tài khoản và
                                nội dung thao tác người dùng đã thực hiện trên hệ thống.
                            </li>
                            <li>Trong trường hợp người dùng đã thanh toán phí nhưng sử dụng hệ thống sai mục đích chúng tôi
                                có quyền ngưng cung cấp dịch vụ ngay lập tức sau khi gửi thông báo đến người dùng và sẽ không hoàn
                                trả phí.
                            </li>
                        </ol>
                    </div>
                    <div name="d5">
                        <h2>Điều 5. Phí dịch vụ</h2>
                        <ol>
                            <li>Người dùng có thể chọn sử dụng dịch vụ này trên cơ sở dùng thử hoặc trả phí. Trong trường
                                hợp sử dụng thử, các chức năng khác nhau có thể sử dụng, số lượng tài khoản, thời gian sử dụng,… có
                                thể bị hạn chế hơn so với sử dụng trả phí.
                            </li>
                            <li>Chi tiết về phí dịch vụ sẽ được xác định riêng trong <a href="#">bảng giá</a> do chúng tôi quy định và chúng
                                tôi có  thể thay đổi phí dịch vụ bằng cách thông báo trước cho người dùng. Nếu người dùng sử dụng
                                dịch vụ này sau khi phí dịch vụ được thay đổi, điều đó có nghĩa là người dùng đã đồng ý áp dụng phí dịch vụ đã
                                thay đổi. Nếu người dùng không đồng ý với mức phí dịch vụ đã thay đổi, người dùng có thể hủy sử
                                dụng trước khi phát sinh phí của tháng kế tiếp.
                            </li>
                            <li>Phí dịch vụ được tính theo đơn vị tháng vì vậy nếu người dùng đã thanh toán phí dịch vụ của
                                1 tháng nhưng không sử dụng hết cũng sẽ không được hoàn trả phần thời gian chưa sử dụng.
                            </li>
                            <li>Người dùng có thể chọn phương thức thanh toán theo tháng hoặc theo năm. Chúng tôi cung cấp
                                giảm giá cho người dùng thanh toán theo năm và lưu ý người dùng sẽ không được hoàn trả phần thời gian
                                chưa sử dụng nếu ngưng sử dụng dịch vụ trước khoảng thời gian đã thanh toán.  
                            </li>
                            <li>Chúng tôi nhận thanh toán bằng hình thức chuyển khoản hoặc liên kết với tài khoản Momo, thẻ
                                tín dụng v.v.. Người dùng chịu trách nhiệm về phí chuyển tiền và các chi phí cần thiết khác để thanh
                                toán.
                            </li>
                            <li>Nếu người dùng trì hoãn việc thanh toán phí dịch vụ trong 7 ngày từ ngày chúng tôi gửi thông
                                báo thanh toán, chúng tôi sẽ đơn phương tạm ngưng tài khoản trong 30 ngày ,sau đó chúng tôi sẽ
                                tiến hành hành xóa vĩnh viễn tài khoản và nội dung thao tác người dùng đã thực hiện trên hệ thống.
                            </li>
                            <li>Ngay cả khi hợp đồng sử dụng bị chấm dứt giữa thời hạn sử dụng, bất kể lý do gì, chúng tôi
                                sẽ không hoàn lại bất kỳ khoản phí dịch vụ nào đã thanh toán.
                            </li>
                        </ol>
                    </div>
                    <div name="d6">
                        <h2>Điều 6. Sử dụng thông tin người dùng</h2>
                        <ol>
                            <li>Chúng tôi quản lý thông tin người dùng và sẽ không sử dụng hoặc sao chép nó cho mục đích khác hoặc cho phép bên thứ ba sử
                                dụng nó, hoặc tiết lộ hoặc rò rỉ nó. </li>
                            <li>Trong những trường hợp sau, chúng tôi có thể tiết lộ một phần hoặc toàn bộ thông tin của người dùng
                                cho bên thứ ba khi :
                                <ol className="serial-number">
                                    <li>Cần thiết để bảo vệ quyền lợi của chúng tôi, đối tác kinh doanh, người dùng khác
                                        hoặc bên thứ ba khi pháp luật yêu cầu (bao gồm cả yêu cầu bằng biểu mẫu điều tra đối với các
                                        vấn đề liên quan đến điều tra) hoặc những trường hợp cần thiết khác.
                                    </li>
                                    <li> Chúng tôi sẽ có thể sử dụng tên và biểu tượng của người dùng cho các mục đích tiếp
                                        thị.
                                    </li>
                                    <li>Chúng tôi sẽ có thể xem thông tin như: dữ liệu nội dung nghiệp vụ được tạo bởi người
                                        dùng cho mục đích mà chúng tôi thấy hợp lý, ví dụ như dùng để ngăn chặn
                                        việc sử dụng trái phép dịch vụ này.
                                    </li>
                                </ol>
                            </li>
                        </ol>
    
                    </div>
                    <div name="d7">
                        <h2>Điều 7. Tạm ngưng hoặc ngưng vĩnh viễn dịch vụ</h2>
                        <div>
                            <p>Chúng tôi có thể tạm ngưng hoặc đình chỉ toàn bộ hoặc một phần việc sử dụng dịch vụ này mà
                                không cần thông báo trước cho người dùng trong bất kỳ trường hợp nào sau đây:
                            </p>
                            <ol>
                                <li>Khi công việc kiểm tra hoặc bảo trì hệ thống máy tính liên quan đến dịch vụ này được
                                    thực hiện thường xuyên hoặc khẩn cấp.
                                </li>
                                <li>Khi máy tính, đường truyền liên lạc, v.v. dừng do tai nạn.</li>
                                <li>Khi dịch vụ này không thể hoạt động do các nguyên nhân bất khả kháng như hỏa hoạn, mất
                                    điện, thiên tai.
                                </li>
                                <li>Ngoài ra, khi chúng tôi xác định rằng việc tạm ngừng là cần thiết.
                                </li>
                            </ol>
                            <p>Chúng tôi có thể chấm dứt việc cung cấp dịch vụ này khi chúng tôi xác định rằng là cần thiết.
                                Trong trường hợp này, chúng tôi sẽ thông báo trước cho người dùng và chúng tôi sẽ không chịu trách
                                nhiệm về bất kỳ thiệt hại nào gây ra cho người dùng. Trong trường hợp này nếu khách hàng đã thanh
                                toán và chúng tôi không thể tiếp tục cung cấp dịch vụ chúng tôi sẽ hoàn trả phần phí dịch vụ khách
                                hàng chưa sử dụng.
                            </p>
                            <p>Chúng tôi có thể chấm dứt việc cung cấp dịch vụ và không hoàn trả chi phí khi người dùng vi
                                phạm bất kỳ nội dung nào của điều khoản sử dụng này.
                            </p>
                        </div>
                    </div>
                    <div name="d8">
                        <h2>Điều 8. Thiết bị và trách nhiệm người dùng</h2>
                        <p>Người dùng cần chuẩn bị máy tính, đường truyền mạng cần thiết để nhận được việc cung cấp dịch vụ.
                        Dịch vụ này sẽ được thực hiện với chi phí và trách nhiệm của người dùng.
                        </p>
                        <p>Người dùng phải thực hiện các biện pháp bảo mật như ngăn ngừa lây nhiễm vi rút máy tính, truy
                            cập trái  phép và rò rỉ thông tin theo môi trường sử dụng dịch vụ của người dùng bằng chi phí và trách nhiệm của
                            chính người dùng.
                        </p>
                    </div>
                    <div name="d9">
                        <h2>Điều 9. Những hành vi bị nghiêm cấm</h2>
                        <div>
                            <ol>
                                <li>
                                    <p>Người dùng không được thực hiện các hành vi sau đây khi sử dụng dịch vụ, ngoài ra, người dùng phải quản lý hợp lý ,không thực hiện các hành vi sau:
                                    </p>
                                    <ol className="serial-number">
                                        <li>Sửa đổi, dịch thuật, bổ sung, phân tích, thiết kế ngược các tài liệu và
                                            chương trình liên quan đến dịch vụ này.
                                        </li>
                                        <li>Các hành vi sử dụng dịch vụ này với mục đích nhận phần thưởng từ các đơn vị liên
                                            kết,v.v.</li>
                                        <li>Hành vi sử dụng dịch vụ này với mục đích truy cập bất hợp pháp vào các hệ thống
                                            khác.
                                        </li>
                                        <li>Các hành vi trực tiếp hoặc gián tiếp phát triển hoặc bán các dịch vụ phái sinh
                                            của dịch vụ này, các dịch vụ giống hoặc tương tự với dịch vụ này, hoặc các hành vi được
                                            sử dụng cho các tiêu chuẩn phát triển mà không được sự cho phép của chúng tôi.
                                        </li>
                                        <li> Bán lại giấy phép của dịch vụ này mà không có sự cho phép của chúng tôi.</li>
                                        <li>Các hành vi vi phạm quyền sở hữu trí tuệ của chúng tôi, đối tác kinh doanh,
                                            người dùng khác và các bên thứ ba khác.
                                        </li>
                                        <li>Các hành vi gây tổn hại đến tài sản, tín dụng, danh dự, v.v. của chúng tôi, đối
                                            tác kinh doanh, người dùng khác và bên thứ ba khác và các hành vi xâm phạm quyền riêng
                                            tư, và các quyền khác.
                                        </li>
                                        <li>Các hành vi gây ra hoặc có thể gây bất lợi hoặc thiệt hại cho chúng tôi, các đối
                                            tác kinh doanh, người dùng khác hoặc các bên thứ ba khác.
                                        </li>
                                        <li>Các hành vi xúc phạm đến trật tự công cộng và đạo đức.</li>
                                        <li>Các hành vi vi phạm pháp luật và các quy định, các hành vi phạm tội, các hành vi
                                            tiếp tay cho tội phạm hoặc các hành vi có thể gây ra các hành vi đó.
                                        </li>
                                        <li>Lừa đảo dưới danh tính của chúng tôi, đối tác, người dùng khác hoặc các trang
                                            web của  bên thứ ba khác.
                                        </li>
                                        <li>Hành vi đăng ký và cung cấp thông tin, dữ liệu bao gồm các chương trình độc
                                            hại.
                                        </li>
                                        <li>Hành động tiết lộ thông tin lỗ hổng không được tiết lộ liên quan đến dịch vụ này
                                            mà không có sự đồng ý của chúng tôi.
                                        </li>
                                        <li>Các hành động gây trở ngại hoặc có thể gây trở ngại cho hoạt động của dịch vụ
                                            này và tất cả các dịch vụ do chúng tôi cung cấp.
                                        </li>
                                        <li>Các hành vi khác mà chúng tôi cho là không phù hợp.</li>
                                        <li>Hành vi sử dụng dịch vụ này để thực hiện việc spam hoặc crawler dữ liệu ở những hệ
                                            thống khác.
                                        </li>
                                    </ol>
                                </li>
                                <li>
                                    <p>Nếu việc sử dụng dịch vụ hoặc tài khoản này của người dùng thuộc bất kỳ nội dung đã
                                        nêu ở trên, chúng tôi sẽ ngưng cung cấp dịch vụ này hoặc đình chỉ việc sử dụng tài khoản,
                                        đồng thời yêu cầu bồi thường thiệt hại.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Chúng tôi sẽ không chịu trách nhiệm về bất kỳ thiệt hại nào gây ra cho người dùng
                                        dựa trên các biện pháp mà chúng tôi đã nêu ở mục 2 điều này.
                                    </p>
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div name="d10">
                        <h2>Điều 10. Tuyên bố từ chối trách nhiệm</h2>
                        <div>
                            <ol>
                                <li>
                                    Chúng tôi không đảm bảo rằng dịch vụ này phù hợp với tất cả mục đích cụ thể của người
                                    dùng, hay có các thông số kỹ thuật, chức năng, giá trị thương mại, độ chính xác, tính hữu
                                    ích mà người dùng mong đợi. Ngoài ra, chúng tôi cũng không đảm bảo rằng việc sử dụng sẽ tuân
                                    thủ các luật và quy định áp dụng cho người dùng, quy tắc của các nhóm ngành, v.v. hay dịch
                                    vụ này sẽ không gây ra bất kỳ vấn đề nào.
                                </li>
                                <li>
                                    Chúng tôi không đảm bảo rằng bất kỳ thiệt hại nào mà người dùng phải gánh chịu do sự
                                    gián đoạn, tạm ngừng, không có sẵn hoặc bãi bỏ việc cung cấp dịch vụ này sẽ được bồi
                                    thường.
                                </li>
                                <li>
                                    Nếu chúng tôi cố ý gây thiệt hại cho người dùng hoặc do sơ suất, chúng tôi sẽ bồi
                                    thường thiệt hại tối đa là một tháng phí dịch vụ cho người dùng. Tuy nhiên, những thiệt hại
                                    trong trường hợp này sẽ không bao gồm những thiệt hại ngẫu nhiên, những thiệt hại gián
                                    tiếp, những thiệt hại đặc biệt, những thiệt hại trong tương lai và những thiệt hại liên quan đến
                                    lợi nhuận bị mất.
                                </li>
                                <li>
                                    Bất chấp các quy định của khoản trên, nếu người dùng sử dụng dịch vụ này miễn phí,
                                    chúng tôi sẽ không chịu trách nhiệm về bất kỳ thiệt hại nào mà người dùng phải gánh chịu liên
                                    quan đến dịch vụ này.
                                </li>
                                <li>
                                    Nếu người dùng gây thiệt hại cho bên thứ ba thông qua việc sử dụng dịch vụ này, người
                                    dùng phải bồi thường thiệt hại bằng chi phí và trách nhiệm của chính người dùng.
                                </li>
                                <li>
                                    Nếu tranh chấp phát sinh giữa người dùng và bên thứ ba thông qua việc sử dụng dịch vụ
                                    này, tranh chấp đó sẽ được giải quyết theo trách nhiệm của người dùng.
                                </li>
                                <li>
                                    Chúng tôi sẽ không chịu trách nhiệm pháp lý đối với bất kỳ thiệt hại và / hoặc mất
                                    mát nào phát sinh trực tiếp, gián tiếp hoặc theo cách khác (bao gồm thiệt hại đặc biệt, ngẫu
                                    nhiên hoặc do hậu quả và / hoặc mất mát) từ việc người dùng sử dụng dịch vụ này.
                                </li>
                                <li>
                                    Với bất kỳ việc sử dụng dịch vụ trên trang web được thực hiện bởi người dùng, đại
                                    diện của người dùng hoặc các bên thứ ba trái phép sử dụng mật khẩu của người dùng với sự đồng
                                    ý của người dùng hoặc bằng hành động ngẫu hứng hoặc sơ suất của người dùng, người dùng, với
                                    tư cách là chủ sở hữu của mật khẩu, đồng ý chịu mọi trách nhiệm cho tất cả các hoạt động xảy
                                    ra với  tài khoản và mật khẩu mà không có bất kỳ tranh chấp hoặc khiếu nại nào nếu có.
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div name="d11">
                        <h2>Điều 11. Quyền sở hữu trí tuệ</h2>
                        <p>Bằng việc sử dụng dịch vụ của chúng tôi, người dùng đã đồng ý rằng không có sự cho phép
                            và/hoặc giấy  phép sử dụng sở hữu trí tuệ được cung cấp cho người dùng trực tiếp hoặc gián tiếp bởi RPA
                            CLOUD.
                            Người dùng không được vi phạm bất kỳ quyền sở hữu trí tuệ nào của RPA CLOUD. Hơn nữa, người
                            dùng không được sao chép, dán, phân phối, tải xuống, tái sản xuất, tái quảng cáo, sửa đổi, xuất
                            bản, thay đổi, phổ biến, sửa đổi, điều chỉnh và/ hoặc sử dụng quyền sở hữu trí tuệ và/ hoặc tất cả nội
                            dung trên trang web dưới bất kì hình thức nào mà không có sự cho phép trước bằng văn bản của
                            chúng tôi.
                        </p>
                    </div>
                    <div name="d12">
                        <h2>Điều 12. Các biện pháp sau khi kết thúc sử dụng dịch vụ</h2>
                        <p>Khi việc sử dụng chấm dứt do yêu cầu của người dùng hoặc do những lý do phát sinh đã nêu ở
                            những điều trên, chúng tôi sẽ có thể xóa dữ liệu, tệp và tất cả các thông tin khác được tạo bởi người
                            dùng trong dịch vụ này theo quyết định của chúng tôi và người dùng sẽ không thể sử dụng lại sau
                            đó... Người dùng phải thực hiện các biện pháp như sao lưu và tự chịu rủi ro.
                        </p>
                    </div>
                    <div name="d13">
                        <h2>Điều 13. Quyền chỉnh sửa và thay đổi</h2>
                            <div>
                                <ol>
                                    <li>
                                        Chúng tôi có quyền thay đổi các Điều khoản theo thời gian. Hơn nữa, chúng tôi
                                        cũng có quyền sửa đổi nội dung và tài liệu có trong trang web và / hoặc hủy việc sử dụng
                                        dịch vụ bất kỳ lúc nào, bao gồm nhưng không giới hạn ở các sửa đổi, bổ sung và thay đổi
                                        giá, thu hồi và / hoặc ngừng cung cấp dịch vụ bất kỳ bất cứ lúc nào và theo quyết định
                                        tuyệt đối của chúng tôi.
                                    </li>
                                    <li>
                                        Việc người dùng tiếp tục truy cập và / hoặc sử dụng trang web sau sự thay đổi và
                                        sửa đổi nói trên sẽ được coi là sự đồng ý chắc chắn của người dùng về sự
                                        thay đổi và sửa đổi nói trên cũng như đồng ý tuân theo những thay đổi đó. Bằng việc tiếp
                                        tục truy cập và sử dụng trang web, người dùng đã đồng ý với các chỉnh sửa và thay
                                        đổi nói trên.
                                    </li>
                                </ol>
                            </div>
                        </div>
                    <div name="d14">
                        <h2>Điều 14. Chính sách bảo hành và bảo trì</h2>
                        <p>Chúng tôi cam kết sửa lỗi liên quan đến kỹ thuật và hướng dẫn khách hàng sử dụng dịch vụ.</p>
                        <p>Thời gian bảo hành chậm nhất là 48 giờ đồng hồ kể từ khi tiếp nhận thông tin từ người dùng
                            không tính ngày lễ tết. Mọi thông tin chúng tôi liên hệ qua email, hoặc các công cụ chat trực tuyến.       
                        </p>
                    </div>
                    <div name="d15">
                        <h2>Điều 15. Thông tin liên lạc</h2>
                            <p>Người dùng có thể liên lạc với chúng tôi qua địa chỉ support@rpa-cloud.io .</p>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}
    export default withTranslate(Vi);